import Tabs from './Tabs';
import { TabHeaderProps, TabsPaddings, TabsProps, TabsThemes } from './types';

export { TabsPaddings, TabsProps, TabsThemes, TabHeaderProps };
export default Tabs;
